import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {openDrawer} from '../../actions/navOptions';
import ReservedSpotButton from '../UserInfoDrawer/ReservedSpotButton';
import AvatarImage from '../AvatarImage';

class UserInfoDrawerOpener extends Component {

  render() {
    const {openDrawer, reservedSpots, avatar} = this.props;

    const reservedSpotButtons = reservedSpots.map((spotId, index) => {
      return (
        <div key={index}>
          <ReservedSpotButton spotId={spotId} />
          <br />
        </div>
      );
    });

    return (
      <span>
        <div className="map-nav__btn pull-right" >
          {reservedSpots.length == 0 && <i className="fa fa-circle color-danger fa-lg" /> }

          <a className="btn btn-default btn-lg drawer-open" onClick={openDrawer}>
            <AvatarImage entity="drawer" avatar={avatar} style={{width: '40px', height: '40px'}}  />
          </a>

          <span className="my-name">{this.props.firstName}</span>
        </div>
        <div className="my-spots">
          {reservedSpotButtons}
        </div>
      </span>
    );
  }

}

const mapStateToProps = (state) => (
  {
    reservedSpots: state.userAccommodationInfo.reservedSpots,
    firstName: state.user.firstName,
    avatar: state.user.avatar
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openDrawer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfoDrawerOpener);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/UserInfoDrawerOpener.js